module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [(_vm.error) ? [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))])] : _vm._e(), (!_vm.error) ? [_c('div', {
    directives: [{
      name: "key-combo",
      rawName: "v-key-combo",
      value: ('t e s t d a t a'),
      expression: "'t e s t d a t a'"
    }]
  }), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.columnGroups), function(column, index) {
    return _c('div', {
      staticClass: "column",
      class: _vm.columnCount === 2 ? 'col-md-6' : 'col-md-12'
    }, [_c('div', {
      staticClass: "form-block white"
    }, [_vm._l((column), function(item) {
      return [(_vm.isFormGroupVisible(item.key)) ? _c('portal-target', {
        key: item.key,
        attrs: {
          "name": item.key
        }
      }) : _vm._e()]
    })], 2), _c('div', {
      staticClass: "row mt-4 mt-md-0 column_footer"
    }, [(index === (_vm.columnCount - 1)) ? [_c('div', {
      staticClass: "col-12 col-md-10 offset-md-1"
    }, [_c('b-button', {
      staticClass: "btn-confirm desktop-confirm",
      attrs: {
        "name": "campaign_desktop_confirm",
        "size": "lg",
        "variant": _vm.$v.$invalid ? "inactive" : "success"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.save($event)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$t('pos.settings.confirm')))]), _c('br'), _vm._v(_vm._s(_vm.$t('pos.settings.move-to-checkout')))])], 1)] : [_c('span', [_vm._v(" ")])]], 2)])
  }))]), _c('div', {
    staticClass: "field_groups"
  }, [(_vm.isFormGroupVisible('customer')) ? _c('portal', {
    attrs: {
      "to": "customer"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isFieldVisible("campaign.customer.name")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "name": "customer_name",
      "label": _vm.$t("draft_field.title.company"),
      "placeholder": _vm.$t("draft_field.placeholder.company"),
      "errors": _vm.$v.campaign.customer.name,
      "readonly": _vm.isFieldReadOnly("customer.name")
    },
    model: {
      value: (_vm.campaign.customer.name),
      callback: function($$v) {
        _vm.campaign.customer.name = $$v
      },
      expression: "campaign.customer.name"
    }
  })], 1) : _vm._e(), (_vm.isFieldVisible("campaign.customer.remote_id")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "name": "remote_id",
      "label": _vm.$t("draft_field.title.customer-remote-id"),
      "placeholder": _vm.$t("draft_field.placeholder.customer-remote-id"),
      "errors": _vm.$v.campaign.customer.remote_id,
      "readonly": _vm.isFieldReadOnly("customer.remote_id")
    },
    model: {
      value: (_vm.campaign.customer.remote_id),
      callback: function($$v) {
        _vm.campaign.customer.remote_id = $$v
      },
      expression: "campaign.customer.remote_id"
    }
  })], 1) : _vm._e(), (_vm.isFieldVisible("campaign.customer.email")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "name": "customer_email",
      "type": "email",
      "label": _vm.$t("draft_field.title.customer-email"),
      "placeholder": _vm.$t("draft_field.placeholder.customer-email"),
      "errors": _vm.$v.campaign.customer.email,
      "readonly": _vm.isFieldReadOnly("customer.email")
    },
    model: {
      value: (_vm.campaign.customer.email),
      callback: function($$v) {
        _vm.campaign.customer.email = $$v
      },
      expression: "campaign.customer.email"
    }
  })], 1) : _vm._e(), (_vm.isFieldVisible("campaign.customer.phone")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "errors": _vm.$v.campaign.customer.phone
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "slot": "label",
      "for": String((_vm._uid + "_phone"))
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.phone')))]), _c('b-input-group', {
    attrs: {
      "slot": "input"
    },
    slot: "input"
  }, [(_vm.availablePhonePrefixes.length > 1) ? _c('b-form-select', {
    staticClass: "phone-prefix",
    attrs: {
      "name": "customer_phone_prefix",
      "options": _vm.availablePhonePrefixes,
      "value-field": "prefix",
      "text-field": "prefix",
      "readonly": _vm.isFieldReadOnly("customer.phone")
    },
    model: {
      value: (_vm.customerPhonePrefix),
      callback: function($$v) {
        _vm.customerPhonePrefix = $$v
      },
      expression: "customerPhonePrefix"
    }
  }) : (_vm.availablePhonePrefixes.length === 1) ? _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.customerPhonePrefix))]) : _vm._e(), _c('b-form-input', {
    attrs: {
      "name": "customer_phone",
      "id": String((_vm._uid + "_phone")),
      "type": "tel",
      "placeholder": _vm.$t("draft_field.placeholder.phone"),
      "readonly": _vm.isFieldReadOnly("customer.phone")
    },
    model: {
      value: (_vm.customerPhone),
      callback: function($$v) {
        _vm.customerPhone = $$v
      },
      expression: "customerPhone"
    }
  })], 1)], 1)], 1) : _vm._e(), (_vm.isFieldVisible("campaign.customer.language") && _vm.multilanguageEnabled) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "errors": _vm.$v.campaign.customer.language
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.customer-language')))]), _c('b-form-select', {
    staticClass: "form-control",
    attrs: {
      "slot": "input",
      "name": "customer_language",
      "options": _vm.languageOptions
    },
    slot: "input",
    model: {
      value: (_vm.selectedLanguage),
      callback: function($$v) {
        _vm.selectedLanguage = $$v
      },
      expression: "selectedLanguage"
    }
  })], 1)], 1) : _vm._e(), (_vm.isFieldVisible("campaign.facebook.email")) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('form-input', {
    attrs: {
      "name": "facebook_email",
      "type": "email",
      "disabled": _vm.campaign.facebook.sameAsCustomerEmail,
      "placeholder": _vm.$t("draft_field.placeholder.facebook-email"),
      "errors": _vm.$v.campaign.facebook.email
    },
    model: {
      value: (_vm.campaign.facebook.email),
      callback: function($$v) {
        _vm.campaign.facebook.email = $$v
      },
      expression: "campaign.facebook.email"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "label",
      "for": String((_vm._uid + "_fb_email"))
    },
    slot: "label"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.facebook-email'))), _c('span', {
    staticClass: "tooltip-custom"
  }, [_c('icon', {
    staticClass: "question-icon",
    attrs: {
      "name": "question-circle",
      "scale": "1.25"
    }
  })], 1), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.tooltip.facebook-email')))])])])])])], 1) : _vm._e(), (_vm.isFieldVisible("campaign.details.leadEmail") && _vm.leadGenerationEnabled()) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "name": "leadEmail",
      "label": _vm.$t("draft_field.title.lead-email"),
      "placeholder": _vm.$t("draft_field.placeholder.lead-email"),
      "errors": _vm.$v.campaign.details.leadEmail,
      "tooltip": _vm.$t('draft_field.tooltip.lead-email')
    },
    model: {
      value: (_vm.leadEmail),
      callback: function($$v) {
        _vm.leadEmail = $$v
      },
      expression: "leadEmail"
    }
  })], 1) : _vm._e(), (_vm.isFieldVisible("campaign.details.leadPhone") && _vm.leadGenerationEnabled()) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "errors": _vm.$v.campaign.details.leadPhone
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "slot": "label",
      "for": String((_vm._uid + "_lead_phone"))
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.lead-phone'))), _c('span', {
    staticClass: "tooltip-custom"
  }, [_c('icon', {
    staticClass: "question-icon",
    attrs: {
      "name": "question-circle",
      "scale": "1.25"
    }
  })], 1), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.tooltip.lead-phone')))])]), _c('b-input-group', {
    attrs: {
      "slot": "input"
    },
    slot: "input"
  }, [(_vm.availablePhonePrefixes.length > 1) ? _c('b-form-select', {
    staticClass: "phone-prefix",
    attrs: {
      "name": "lead_phone_prefix",
      "options": _vm.availablePhonePrefixes,
      "value-field": "prefix",
      "text-field": "prefix"
    },
    model: {
      value: (_vm.customerPhonePrefix),
      callback: function($$v) {
        _vm.customerPhonePrefix = $$v
      },
      expression: "customerPhonePrefix"
    }
  }) : (_vm.availablePhonePrefixes.length === 1) ? _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.customerPhonePrefix))]) : _vm._e(), _c('b-form-input', {
    attrs: {
      "name": "leadPhone",
      "id": String((_vm._uid + "_lead_phone")),
      "type": "tel",
      "placeholder": _vm.$t("draft_field.placeholder.phone")
    },
    model: {
      value: (_vm.leadPhone),
      callback: function($$v) {
        _vm.leadPhone = $$v
      },
      expression: "leadPhone"
    }
  })], 1)], 1)], 1) : _vm._e()])])]) : _vm._e(), (_vm.isFormGroupVisible('campaign_salesrep_details')) ? _c('portal', {
    attrs: {
      "to": "campaign_salesrep_details"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isFieldVisible("campaign.details.salesrep.phone")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "errors": _vm.$v.campaign.details.salesRepPhone
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "slot": "label",
      "for": String((_vm._uid + "_salesrep_phone"))
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.salesrep_phone')))]), _c('b-input-group', {
    attrs: {
      "slot": "input"
    },
    slot: "input"
  }, [(_vm.availablePhonePrefixes.length > 1) ? _c('b-form-select', {
    staticClass: "phone-prefix",
    attrs: {
      "name": "salesrep_phone_prefix",
      "options": _vm.availablePhonePrefixes,
      "value-field": "prefix",
      "text-field": "prefix"
    },
    model: {
      value: (_vm.customerPhonePrefix),
      callback: function($$v) {
        _vm.customerPhonePrefix = $$v
      },
      expression: "customerPhonePrefix"
    }
  }) : (_vm.availablePhonePrefixes.length === 1) ? _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.customerPhonePrefix))]) : _vm._e(), _c('b-form-input', {
    attrs: {
      "name": "salesrep_phone",
      "id": String((_vm._uid + "_salesrep_phone")),
      "type": "tel",
      "placeholder": _vm.$t("draft_field.placeholder.phone")
    },
    model: {
      value: (_vm.salesRepPhone),
      callback: function($$v) {
        _vm.salesRepPhone = $$v
      },
      expression: "salesRepPhone"
    }
  })], 1)], 1)], 1) : _vm._e()])])]) : _vm._e(), (_vm.isFormGroupVisible('campaign_address')) ? _c('portal', {
    attrs: {
      "to": "campaign_addresss"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isFieldVisible("campaign.local_advertising_address")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "name": "customer_street_address",
      "label": _vm.$t("generic.customer-street-address"),
      "placeholder": _vm.$t("campaign.placeholder.customer-street-address"),
      "errors": _vm.$v.campaign.local_advertising_address
    },
    model: {
      value: (_vm.campaign.local_advertising_address),
      callback: function($$v) {
        _vm.campaign.local_advertising_address = $$v
      },
      expression: "campaign.local_advertising_address"
    }
  })], 1) : _vm._e()])])]) : _vm._e(), (_vm.isFormGroupVisible('campaign_facebook')) ? _c('portal', {
    attrs: {
      "to": "campaign_facebook"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isFieldVisible("campaign.facebook.hasFacebookPage")) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('facebook-page-creation', {
    ref: "fbPageCreator",
    attrs: {
      "hasFacebookPage": _vm.campaign.facebook.hasFacebookPage,
      "creationMode": _vm.campaign.facebook.creationMode,
      "extraCostFacebookPage": _vm.campaign.details.extraCostFacebookPage
    },
    on: {
      "update:hasFacebookPage": function($event) {
        _vm.campaign.facebook.hasFacebookPage = $event
      },
      "update:creationMode": function($event) {
        _vm.campaign.facebook.creationMode = $event
      },
      "update:extraCostFacebookPage": function($event) {
        _vm.campaign.details.extraCostFacebookPage = $event
      }
    }
  })], 1) : _vm._e(), (_vm.isFieldVisible("campaign.facebook.page") && _vm.campaign.facebook.hasFacebookPage) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('form-input', {
    attrs: {
      "errors": _vm.$v.campaign.facebook.page
    }
  }, [_c('facebook-connector', {
    attrs: {
      "slot": "input",
      "page": _vm.campaign.facebook.page
    },
    on: {
      "update:page": function($event) {
        _vm.campaign.facebook.page = $event
      }
    },
    slot: "input"
  })], 1)], 1) : _vm._e()])])]) : _vm._e(), (_vm.isFormGroupVisible('campaign_lead_details')) ? _c('portal', {
    attrs: {
      "to": "campaign_lead_details"
    }
  }, [(_vm.leadGenerationEnabled()) ? _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.leadPrivacyPolicyLink()) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "name": "leadPrivacyLink",
      "disabled": _vm.campaign.create_landing_page,
      "label": _vm.$t("draft_field.title.privacy-policy-link"),
      "placeholder": _vm.$t("draft_field.placeholder.privacy-policy-link"),
      "errors": _vm.$v.campaign.details.leadPrivacyLink,
      "tooltip": _vm.$t("draft_field.tooltip.privacy-policy-link")
    },
    model: {
      value: (_vm.leadPrivacyLink),
      callback: function($$v) {
        _vm.leadPrivacyLink = $$v
      },
      expression: "leadPrivacyLink"
    }
  })], 1) : _vm._e(), (_vm.leadQuestionVisible() && _vm.isFieldVisible("campaign.details.form_question")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "name": "form_question",
      "label": _vm.$t("draft_field.title.form-question"),
      "placeholder": _vm.$t("draft_field.placeholder.form-question")
    },
    model: {
      value: (_vm.campaign.details.form_question),
      callback: function($$v) {
        _vm.campaign.details.form_question = $$v
      },
      expression: "campaign.details.form_question"
    }
  })], 1) : _vm._e()])]) : _vm._e()]) : _vm._e(), (_vm.isFormGroupVisible('campaign_base')) ? _c('portal', {
    attrs: {
      "to": "campaign_base"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isFieldVisible("campaign.name")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', {
    attrs: {
      "name": "campaign_name",
      "label": _vm.$t("draft_field.title.name"),
      "placeholder": _vm.$t("draft_field.placeholder.name"),
      "errors": _vm.$v.campaign.name
    },
    model: {
      value: (_vm.campaign.name),
      callback: function($$v) {
        _vm.campaign.name = $$v
      },
      expression: "campaign.name"
    }
  })], 1) : _vm._e(), (_vm.isFieldVisible("campaign.start_date")) ? _c('div', {
    staticClass: "col-12",
    class: {
      "datepicker-open": _vm.datepickerOpened
    }
  }, [_c('form-input', {
    attrs: {
      "errors": _vm.$v.campaign.start_date
    }
  }, [_c('template', {
    attrs: {
      "slot": "label",
      "for": String((_vm._uid + "_start_date"))
    },
    slot: "label"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      "col-6": _vm.statusFlowVisible, "col-12": !_vm.statusFlowVisible
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.start-date')))])]), (_vm.statusFlowVisible) ? _c('div', {
    staticClass: "col-6 text-right initialism"
  }, [_vm._v(_vm._s(_vm.STATUS_FLOW_ASAP) + " "), _c('switches', {
    attrs: {
      "name": "campaign_flow",
      "value": _vm.campaign.flow === _vm.STATUS_FLOW_ASAP,
      "type-bold": true,
      "theme": "custom"
    },
    on: {
      "input": _vm.onChangeEventHandler
    }
  })], 1) : _vm._e()])]), _c('correct-datepicker', {
    attrs: {
      "slot": "input",
      "name": "campaign_start_date",
      "disabled": {
        to: _vm.minStart,
        customPredictor: _vm.disabledMonthDays,
        from: _vm.maxStart
      },
      "placeholder": _vm.startDatePlaceholder,
      "readonly": _vm.isStartDateReadonly,
      "id": String((_vm._uid + "_start_date"))
    },
    on: {
      "toggle": function (open) { return _vm.datepickerOpened = open; }
    },
    slot: "input",
    model: {
      value: (_vm.campaign.start_date),
      callback: function($$v) {
        _vm.campaign.start_date = $$v
      },
      expression: "campaign.start_date"
    }
  })], 2)], 1) : _vm._e(), (_vm.showSkipOnboarding) ? _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "skip-onboarding",
      "unchecked-value": false
    },
    model: {
      value: (_vm.skipOnboarding),
      callback: function($$v) {
        _vm.skipOnboarding = $$v
      },
      expression: "skipOnboarding"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.settings.skip-onboarding')))])], 1) : _vm._e()])])]) : _vm._e(), (_vm.isFormGroupVisible('campaign_setup')) ? _c('portal', {
    attrs: {
      "to": "campaign_setup"
    }
  }, [(_vm.isFieldVisible("campaign.landing_page.url") && !_vm.isPostEngagement) ? _c('div', {
    staticClass: "col-md-12 landing"
  }, [_c('form-input', {
    class: {
      "error-input": _vm.invalidUrl
    },
    attrs: {
      "name": "landing_page_url",
      "placeholder": _vm.landingPagePlaceholder,
      "errors": _vm.landingPageErrors,
      "disabled": _vm.campaign.create_landing_page
    },
    model: {
      value: (_vm.campaign.landing_page.url),
      callback: function($$v) {
        _vm.campaign.landing_page.url = $$v
      },
      expression: "campaign.landing_page.url"
    }
  }, [_c('template', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 my-auto"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.landing-page')))])]), _c('div', {
    staticClass: "col-md-8 text-left text-md-right"
  }, [(!_vm.isPageFacebook) ? _c('b-form-radio', {
    attrs: {
      "name": "landing_page_type",
      "options": _vm.landingPageTypes,
      "size": "sm",
      "disabled": _vm.campaign.create_landing_page
    },
    model: {
      value: (_vm.campaign.landing_page.type),
      callback: function($$v) {
        _vm.campaign.landing_page.type = $$v
      },
      expression: "campaign.landing_page.type"
    }
  }) : _vm._e(), (_vm.isFieldVisible('campaign.create-landing-page')) ? _c('div', {
    staticClass: "disable-landing"
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "create-landing-page",
      "unchecked-value": false,
      "size": "sm"
    },
    on: {
      "change": _vm.onChangeDisableLandingPage
    },
    model: {
      value: (_vm.campaign.create_landing_page),
      callback: function($$v) {
        _vm.campaign.create_landing_page = $$v
      },
      expression: "campaign.create_landing_page"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.settings.create-landing-page')))])], 1) : _vm._e()], 1)])]), (_vm.invalidUrl) ? _c('span', {
    staticClass: "error-url-text"
  }, [_vm._v(_vm._s(_vm.$t('error.validation.isUrl')))]) : _vm._e()], 2)], 1) : _vm._e(), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isFieldVisible("campaign.objective") && !_vm.localOffersEnabled) ? _c('div', {
    staticClass: "col-12"
  }, [_c('label', {
    staticClass: "label parent-label",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('pos.format.modal.objectives.label')))]), (_vm.campaign.objective) ? _c('label', {
    staticClass: "objective-container"
  }, [_vm._v(_vm._s(_vm.$t('terms.objective-texts.format', {
    slug: _vm.campaign.objective
  })))]) : _vm._e(), _c('form-input', {
    staticClass: "text-lg-right objective-modal",
    attrs: {
      "errors": _vm.$v.campaign.objective
    }
  }, [_c('b-btn', {
    style: ({
      marginLeft: '15px'
    }),
    attrs: {
      "slot": "input",
      "name": "show_modal_objectives"
    },
    on: {
      "click": _vm.showModalObjectives
    },
    slot: "input"
  }, [(!_vm.campaign.objective) ? [_vm._v(_vm._s(_vm.$t('draft_field.placeholder.objective')))] : (_vm.campaign.objective) ? [_vm._v(_vm._s(_vm.$t('draft_field.placeholder.change')))] : _vm._e()], 2)], 1), _c('div', {
    staticClass: "line"
  })], 1) : _vm._e(), (_vm.isFieldVisible("campaign.brief")) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('form-input', {
    attrs: {
      "label": _vm.$t("draft_field.title.brief"),
      "errors": _vm.$v.campaign.brief,
      "rows": 3
    }
  }, [_c('div', {
    staticClass: "textarea-wrapper",
    attrs: {
      "slot": "input"
    },
    slot: "input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.brief),
      expression: "campaign.brief"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "campaign_brief",
      "type": "text",
      "rows": 3,
      "placeholder": _vm.briefPlaceholder
    },
    domProps: {
      "value": (_vm.campaign.brief)
    },
    on: {
      "scroll": _vm.calculateBackgroundPosition,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.campaign.brief = $event.target.value
      }
    }
  })])])], 1) : _vm._e(), (_vm.isFieldVisible("campaign.images")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('form-input', [_c('label', {
    staticClass: "label",
    attrs: {
      "slot": "label",
      "for": String((_vm._uid + "_phone"))
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.images')))]), _c('file-upload', {
    attrs: {
      "slot": "input",
      "name": "brief_images",
      "images": _vm.campaign.images
    },
    on: {
      "update:images": function($event) {
        _vm.campaign.images = $event
      }
    },
    slot: "input"
  })], 1)], 1) : _vm._e(), (_vm.localOffersEnabled) ? _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form-input', [_c('label', {
    staticClass: "label",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.offer-settings')))]), _c('b-button', {
    style: ({
      marginLeft: '15px'
    }),
    attrs: {
      "slot": "input",
      "name": "show_offer_settings",
      "size": "lg"
    },
    on: {
      "click": function($event) {
        _vm.showModalOfferSettings()
      }
    },
    slot: "input"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pos.settings.setup-offer')))])])], 1), _c('b-form-checkbox', {
    attrs: {
      "name": "same_offer",
      "size": "sm",
      "unchecked-value": false
    },
    model: {
      value: (_vm.sameOffer),
      callback: function($$v) {
        _vm.sameOffer = $$v
      },
      expression: "sameOffer"
    }
  }, [_vm._v(_vm._s(_vm.$t('draft_field.offer_settings.same_offer')))])], 1)])]) : _vm._e()])])]) : _vm._e(), (_vm.isFormGroupVisible('campaign_details')) ? _c('portal', {
    attrs: {
      "to": "campaign_details"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isFieldVisible("campaign.details.notify_customer")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "notify_customer",
      "size": "sm",
      "unchecked-value": false
    },
    model: {
      value: (_vm.notifyCustomer),
      callback: function($$v) {
        _vm.notifyCustomer = $$v
      },
      expression: "notifyCustomer"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.settings.notify-customer-also')))])], 1) : _vm._e(), (_vm.isFieldVisible("campaign.details.appointed_onboarding") && _vm.showOnboardingField()) ? _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "appointed_onboarding",
      "size": "sm",
      "unchecked-value": false
    },
    model: {
      value: (_vm.appointed_onboarding),
      callback: function($$v) {
        _vm.appointed_onboarding = $$v
      },
      expression: "appointed_onboarding"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.settings.appointed-onboarding')))])], 1) : _vm._e()])])]) : _vm._e(), (_vm.isFormGroupVisible('allied')) ? _c('portal', {
    attrs: {
      "to": "allied"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.isFieldVisible("campaign.details.alliedCoupon")) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-4 text-right coupon-switch"
  }, [_c('switches', {
    attrs: {
      "name": "has_coupon",
      "value": _vm.couponEnabled,
      "type-bold": true,
      "theme": "custom",
      "emit-on-mount": false
    },
    on: {
      "input": _vm.onChangeCouponEventHandler
    }
  })], 1), _c('form-input', {
    attrs: {
      "name": "coupon_code",
      "disabled": !_vm.couponEnabled,
      "label": _vm.$t("draft_field.title.coupon-code"),
      "placeholder": _vm.$t("draft_field.title.coupon-code"),
      "errors": _vm.$v.campaign.details.alliedCoupon
    },
    model: {
      value: (_vm.couponCode),
      callback: function($$v) {
        _vm.couponCode = $$v
      },
      expression: "couponCode"
    }
  })], 1) : _vm._e()])])]) : _vm._e()], 1), _c('b-button', {
    staticClass: "btn-confirm mobile-confirm main-confirm",
    attrs: {
      "name": "campaign_main_confirm",
      "size": "lg",
      "variant": _vm.$v.$invalid ? "inactive" : "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.save($event)
      },
      "!click": function($event) {
        _vm.doThis($event)
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pos.settings.confirm')))]), _c('br'), _vm._v(_vm._s(_vm.$t('pos.settings.move-to-checkout')))]), _c('b-modal', {
    ref: "modal",
    staticClass: "creator-modal",
    attrs: {
      "size": "lg",
      "closeTitle": _vm.$t('terms.misc.close'),
      "okTitle": _vm.$t('terms.misc.confirm'),
      "ok-disabled": _vm.objectiveTemp ? false : true
    },
    on: {
      "ok": _vm.setObjective
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("pos.format.modal.objectives.title")))])]), _c('b-form-radio', {
    staticClass: "available-objective",
    attrs: {
      "buttons": "buttons",
      "stacked": "stacked",
      "name": "available-objective",
      "options": _vm.availableObjectives
    },
    model: {
      value: (_vm.objectiveTemp),
      callback: function($$v) {
        _vm.objectiveTemp = $$v
      },
      expression: "objectiveTemp"
    }
  })], 1), (_vm.localOffersEnabled) ? _c('b-modal', {
    ref: "modalOfferSettings",
    attrs: {
      "hide-header": "hide-header",
      "hide-footer": "hide-footer",
      "size": "lg"
    },
    on: {
      "hidden": _vm.hiddenOfferSettings
    }
  }, [_c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.offer_settings.header')))]), _c('form-input', {
    attrs: {
      "name": "offer_title",
      "label": _vm.$t("draft_field.offer_settings.title"),
      "maxlength": _vm.maxLengthFields.offer_settings.title,
      "className": "single-line"
    },
    model: {
      value: (_vm.campaign.offer_settings.title),
      callback: function($$v) {
        _vm.campaign.offer_settings.title = $$v
      },
      expression: "campaign.offer_settings.title"
    }
  }), _c('form-input', {
    staticClass: "single-line",
    attrs: {
      "name": "offer_details",
      "label": _vm.$t("draft_field.offer_settings.details"),
      "maxlength": _vm.maxLengthFields.offer_settings.details,
      "className": "single-line"
    },
    model: {
      value: (_vm.campaign.offer_settings.details),
      callback: function($$v) {
        _vm.campaign.offer_settings.details = $$v
      },
      expression: "campaign.offer_settings.details"
    }
  }), _c('div', {
    staticClass: "form-group single-line",
    class: [{
      "form-error": _vm.offerModalErrors.code_type
    }]
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.offer_settings.code_type')))]), _c('div', {
    staticClass: "input-container top-align"
  }, [_c('b-form-select', {
    staticClass: "form-control",
    attrs: {
      "name": "offer_code_type",
      "options": _vm.offersCodeTypeOptions,
      "state": !_vm.offerModalErrors.code_type
    },
    on: {
      "input": _vm.checkCodeVisible
    },
    model: {
      value: (_vm.campaign.offer_settings.code_type),
      callback: function($$v) {
        _vm.campaign.offer_settings.code_type = $$v
      },
      expression: "campaign.offer_settings.code_type"
    }
  }), (_vm.offerModalErrors.code_type) ? _c('ul', {
    staticClass: "errors-list"
  }, [_c('li', [_vm._v(_vm._s(this.$t('error.validation.code_type')))])]) : _vm._e()], 1), (_vm.offerCodeVisible) ? _c('div', {
    staticClass: "input-container top-align"
  }, [_c('form-input', {
    attrs: {
      "name": "offer_code",
      "placeholder": _vm.$t("draft_field.offer_settings.placeholder.code"),
      "maxlength": _vm.maxLengthFields.offer_settings.code,
      "state": !_vm.offerModalErrors.unique_code
    },
    on: {
      "input": _vm.checkUniqueCode
    },
    model: {
      value: (_vm.campaign.offer_settings.code),
      callback: function($$v) {
        _vm.campaign.offer_settings.code = $$v
      },
      expression: "campaign.offer_settings.code"
    }
  }), (_vm.offerModalErrors.unique_code) ? _c('ul', {
    staticClass: "errors-list"
  }, [_c('li', [_vm._v(_vm._s(this.$t('error.validation.unique_code')))])]) : _vm._e()], 1) : _vm._e()]), _c('div', {
    staticClass: "form-group single-line",
    class: [{
      "form-error": _vm.offerModalErrors.redeem_options
    }]
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.offer_settings.redeem')))]), _c('b-form-select', {
    staticClass: "form-control",
    attrs: {
      "name": "offer_redeem",
      "options": _vm.offersRedeemOptions,
      "state": !_vm.offerModalErrors.redeem_options
    },
    on: {
      "input": _vm.checkRedeemUrlVisible
    },
    model: {
      value: (_vm.campaign.offer_settings.redeem),
      callback: function($$v) {
        _vm.campaign.offer_settings.redeem = $$v
      },
      expression: "campaign.offer_settings.redeem"
    }
  }), (_vm.offerModalErrors.redeem_options) ? _c('ul', {
    staticClass: "errors-list"
  }, [_c('li', [_vm._v(_vm._s(this.$t('error.validation.redeem_options')))])]) : _vm._e()], 1), (_vm.offerRedeemUrlVisible) ? _c('form-input', {
    attrs: {
      "name": "offer_url",
      "label": _vm.$t("draft_field.offer_settings.offer_url"),
      "errors": _vm.offerModalErrors.url,
      "className": "single-line"
    },
    model: {
      value: (_vm.campaign.offer_settings.offer_url),
      callback: function($$v) {
        _vm.campaign.offer_settings.offer_url = $$v
      },
      expression: "campaign.offer_settings.offer_url"
    }
  }) : _vm._e(), _c('form-input', {
    attrs: {
      "name": "offer_terms",
      "label": _vm.$t("draft_field.offer_settings.t_c"),
      "maxlength": _vm.maxLengthFields.offer_settings.t_c,
      "className": "single-line"
    },
    model: {
      value: (_vm.campaign.offer_settings.t_c),
      callback: function($$v) {
        _vm.campaign.offer_settings.t_c = $$v
      },
      expression: "campaign.offer_settings.t_c"
    }
  }), _c('div', {
    staticClass: "modal-footer"
  }, [_c('b-button', {
    staticClass: "btn-cancelmodal",
    attrs: {
      "size": "md"
    },
    on: {
      "click": _vm.hideOfferSettingsModal
    }
  }, [_vm._v(_vm._s(_vm.$t('terms.misc.cancel')))]), _c('b-button', {
    staticClass: "btn-primary",
    attrs: {
      "size": "md"
    },
    on: {
      "click": _vm.saveOfferSettings
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.settings.confirm')))])], 1)], 1)]) : _vm._e()] : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99091ea0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-settings/CampaignSettings.vue
// module id = 954
// module chunks = 1